define('core/base-runner',["exports", "core/utils", "core/post-process", "core/pre-process", "core/pubsubhub", "core/include-config", "core/override-configuration", "core/respec-ready"], function (exports, _utils, _postProcess, _preProcess, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.runAll = runAll;
  const name = exports.name = "core/base-runner"; // Module core/base-runner
  // The module in charge of running the whole processing pipeline.

  const canMeasure = performance.mark && performance.measure;

  function toRunnable(plug) {
    const name = plug.name || "";
    if (!name) {
      console.warn("Plugin lacks name:", plug);
    }
    return config => {
      return new Promise(async (resolve, reject) => {
        const timerId = setTimeout(() => {
          const msg = `Plugin ${name} took too long.`;
          console.error(msg, plug);
          reject(new Error(msg));
        }, 15000);
        if (canMeasure) {
          performance.mark(name + "-start");
        }
        try {
          // Modern plugins are async or normal functions, take zero or one argument (conf)
          if (plug.run.length <= 1) {
            await plug.run(config);
            resolve();
          } else {
            plug.run(config, document, resolve);
          }
        } catch (err) {
          reject(err);
        } finally {
          clearTimeout(timerId);
        }
        if (canMeasure) {
          performance.mark(name + "-end");
          performance.measure(name, name + "-start", name + "-end");
        }
      });
    };
  }

  async function runAll(plugs) {
    (0, _pubsubhub.pub)("start-all", respecConfig);
    // TODO: assign defaults properly
    if (!respecConfig.definitionMap) {
      respecConfig.definitionMap = Object.create(null);
    }
    if (canMeasure) {
      performance.mark(name + "-start");
    }
    await _preProcess.done;
    const runnables = plugs.filter(plug => plug && plug.run).map(toRunnable);
    for (const task of runnables) {
      try {
        await task(respecConfig);
      } catch (err) {
        console.error(err);
      }
    }
    (0, _pubsubhub.pub)("plugins-done", respecConfig);
    await _postProcess.done;
    (0, _pubsubhub.pub)("end-all", respecConfig);
    (0, _utils.removeReSpec)(document);
    if (canMeasure) {
      performance.mark(name + "-end");
      performance.measure(name, name + "-start", name + "-end");
    }
  }
});
//# sourceMappingURL=base-runner.js.map;
